import React from 'react';

import classNames from 'classnames';

import CheckIcon from 'Assets/icons/check.svg';

/**
 * The marker that carries a step's status at a glance: a tick when it is done,
 * a half-filled ring when it was left until later, its number among the visible steps otherwise.
 */
export default function StepStatusMarker({ step, active, number }) {
    const { status } = step;

    if (status === 'complete') {
        return (
            <span className="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-rounded-full tw-bg-green tw-text-dark-green">
                <CheckIcon className="tw-w-3.5 tw-h-3.5" />
            </span>
        );
    }

    if (status === 'pending') {
        return (
            <span
                className={classNames(
                    'tw-flex tw-shrink-0 tw-overflow-hidden tw-w-6 tw-h-6 tw-rounded-full tw-border-2',
                    active ? 'tw-border-white' : 'tw-border-blue',
                )}
            >
                <span className={classNames('tw-w-1/2', active ? 'tw-bg-white' : 'tw-bg-blue')} />
            </span>
        );
    }

    return (
        <span
            className={classNames(
                'tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-rounded-full tw-border-2 tw-text-2xs tw-font-medium',
                {
                    'tw-border-transparent tw-bg-white/20 tw-text-white': active,
                    'tw-border-blue tw-text-blue': !active && status === 'in_progress',
                    'tw-border-charcoal-25 tw-text-charcoal-60': !active && status !== 'in_progress',
                },
            )}
        >
            {number}
        </span>
    );
}
